import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import {
  groupMatches,
  groupRounds,
  convertToMatchCellProps,
  toColumns,
} from 'src/components/tournaments/brackets/util/bracketFunctions';
import { useMemo } from 'react';

export const useGenerateBracket = (rounds) => {
  const [roundsLeft, roundsRight, roundsCenter] = groupRounds(rounds);

  const matchesLeftGrouped = groupMatches(roundsLeft);
  const matchesRightGrouped = groupMatches(roundsRight);
  const matchesCenterGrouped = groupMatches(roundsCenter);
  const matchesMobileGrouped = rounds.map((round) => {
    if (!!round.matches) {
      return { matches: round.matches };
    }
    return { matches: [] };
  });

  const matchesLeftProps = convertToMatchCellProps(matchesLeftGrouped);
  const matchesRightProps = convertToMatchCellProps(matchesRightGrouped);
  const matchesCenterProps = convertToMatchCellProps(
    matchesCenterGrouped,
    true,
  );
  const matchesMobileProps = convertToMatchCellProps(
    matchesMobileGrouped,
    true,
  );

  const matchColumnsLeft = toColumns(
    matchesLeftProps.slice(0, matchesLeftProps.length - 1),
    'left',
    rounds.length,
  );

  const matchColumnCenter = toColumns(
    !!matchesLeftProps.length && !!matchesRightProps.length
      ? [
          {
            matches: [
              ...matchesLeftProps[matchesLeftProps.length - 1].matches,
              ...matchesCenterProps[0].matches,
              ...matchesRightProps[matchesRightProps.length - 1].matches,
            ],
          },
        ]
      : matchesCenterProps,
    'center',
    rounds.length,
  );

  const matchColumnsRight = toColumns(
    matchesRightProps.slice(0, matchesRightProps.length - 1).reverse(),
    'right',
    rounds.length,
  );

  const mobileColumns = useMemo(() => {
    return matchesMobileProps.map((column) => {
      return (
        <Stack
          direction="column"
          spacing={4}
          alignItems="center"
          justifyContent="space-around"
          key={column.matches[0].matchId}
        >
          {column.matches.map((matchObj) => {
            return <Box key={matchObj.matchId}>{matchObj.match}</Box>;
          })}
        </Stack>
      );
    });
  }, [matchesMobileProps]);
  return {
    matchColumnsLeft,
    matchColumnCenter,
    matchColumnsRight,
    mobileColumns,
  };
};
